import alarm from "./alarm"


export default {alarm}